import { gql, TypedDocumentNode } from '@apollo/client';

import { CategoryType } from '@shared/components/magazin/types';

export const GET_GHOST_CATEGORIES: TypedDocumentNode<{ getGhostCategories: { categories: CategoryType[] } }> = gql`
  query getGhostCategories {
    getGhostCategories {
      categories {
        id
        name
        slug
        subCategories {
          name
          slug
          ghostSlug
        }
      }
    }
  }
`;
